/**
 * =============================================================================
 * animation.js
 * =============================================================================

 * =============================================================================
 */

var Animation = {
  /**
   * Initialisation
   */
  init: function() {

  }
}

export default Animation;
